__turbopack_context__.v({
  "marquee": "SuggestiveChips-module__vVRc8W__marquee",
  "marqueeAnim": "SuggestiveChips-module__vVRc8W__marqueeAnim",
  "marqueeContent": "SuggestiveChips-module__vVRc8W__marqueeContent",
  "marqueeItem": "SuggestiveChips-module__vVRc8W__marqueeItem",
  "root": "SuggestiveChips-module__vVRc8W__root",
});
